const getPlayIconSize = (playerWidth: number) =>
  playerWidth <= 540
    ? 56
    : playerWidth <= 720
    ? 70
    : playerWidth <= 1000
    ? 90
    : 120;

export default getPlayIconSize;
